import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { UnitsService } from 'src/app/core/services/units.service';
import { CasesService } from 'src/app/core/services/cases.service';
import { TransferCaseService } from 'src/app/services/transfer_case_service.service';
import { UserService } from 'src/app/core/services/user.service';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';

@Component({
  selector: 'app-remitir-csa',
  templateUrl: './remitir-csa.component.html',
  styleUrls: ['./remitir-csa.component.scss'],
})
export class RemitirCsaComponent implements OnInit {
  units: any[] = [];
  loading = false;

  form = this.fb.group({
    unitId: [null, [Validators.required]],
    observation: [''],
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<RemitirCsaComponent>,
    private readonly fb: FormBuilder,
    private readonly unitService: UnitsService,
    private readonly casesService: CasesService,
    private readonly transferCaseService: TransferCaseService,
    private readonly userService: UserService,
    private readonly dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.unitService.getAll().subscribe({
      next: (res: any) => {
        // Only allow remittance to these CSA units
        const allowed = ['CAI Asuntos Internos', 'CAE Asuntos Externos'];
        this.units = Array.isArray(res)
          ? res.filter((u: any) => allowed.includes(u.name))
          : [];
        this.loading = false;
      },
      error: () => (this.loading = false),
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  alert(message: string) {
    this.dialog.open(SuccessComponent, { data: { title: message } });
  }

  submit() {
    if (!this.form.valid) return;
    const unitId = this.form.value.unitId;
    const transferData = {
      userId: this.userService.currentUser?._id,
      remittalComment: this.form.value.observation || '',
      copyFiles: true,
    };

    this.loading = true;
    this.transferCaseService
      .transferToUnits(this.data._id, unitId, transferData)
      .subscribe({
        next: (res) => {
          this.loading = false;
          this.alert('Caso remitido correctamente');
          this.dialogRef.close(res);
        },
        error: (err) => {
          console.error('transferToUnits error', err);
        },
      });
  }
}
